import React from 'react';

import { IPlanInfoFields } from '../../../types/contentful';

import RichText from '../RichText';

import {
  Logo,
  PlanInfoWrapper,
  TextWrapper,
  LogoWrapper,
  ButtonWrapper
} from './styles';

export function PlanInfo({ color, logo, copy, button }: IPlanInfoFields) {
  const { file, description } = logo?.fields ?? {};

  return (
    <PlanInfoWrapper role="listitem" data-testid="plans-info">
      {file && (
        <LogoWrapper color={color ?? ''}>
          <div style={{ position: 'relative', width: '75%' }}>
            <Logo
              src={`https:${file?.url}`}
              alt={description ?? ''}
              height={56}
              width={239}
            />
          </div>
        </LogoWrapper>
      )}
      <TextWrapper>
        {copy && (
          <div>
            <RichText data={copy} />
          </div>
        )}
        {button && (
          <ButtonWrapper>
            <RichText data={button} />
          </ButtonWrapper>
        )}
      </TextWrapper>
    </PlanInfoWrapper>
  );
}
